<ng-container *transloco="let t">
  <div class="mb-4 flex items-center justify-between border-b border-gray-100 pb-4">
    <div class="flex w-full items-center justify-end">
      <button iButton [disabled]="!canPreview()" (click)="emitPreview()">
        {{ t("common.next") }}
      </button>
    </div>
  </div>
  @if (fileMetadata() && !isPlainText()) {
    @let metadata = fileMetadata()!;
    <div class="flex h-full w-full items-center justify-center">
      <div class="w-[20rem] rounded-xl border border-gray-100 p-5">
        <div class="flex min-w-0 items-center justify-between gap-2 truncate text-sm text-gray-700">
          <span class="truncate" [iTooltip]="metadata.name" iTooltipPlacement="top-center">{{ metadata.name }}</span>

          <button
            iButton
            variant="ghost"
            size="icon-sm"
            class="shrink-0 [&>IIcon]:text-gray-500"
            (click)="removeFile.emit()"
          >
            <IIcon name="trash" />
          </button>
        </div>
        <div class="my-4 border-y border-gray-100 py-4 text-sm text-gray-500">
          <p>
            {{ t("bulk-upload-file.file_type_file_description", [metadata.type, (metadata.size / 1024).toFixed(2)]) }}
          </p>
          <p>{{ t("bulk-upload-file.rows_count", [metadata.rows.length]) }}</p>
        </div>

        <div>
          <button iButton class="w-full" (click)="emitPreview()">
            {{ t("common.next") }}
          </button>
        </div>
      </div>
    </div>
  } @else {
    <div class="mx-auto flex h-full w-[min(90%,60rem)] flex-col items-center justify-center gap-4">
      <div class="text-sm text-gray-500">
        {{ t("bulk-upload.bulk_upload_file_description") }}
        <button iButton variant="secondary" (click)="export.emit()" size="xs">
          {{ t("bulk-upload.export_strategies") }}
        </button>
      </div>
      <textarea
        id="bulk-upload-textarea"
        autofocus
        class="h-[250px] w-full resize-y border-gray-200"
        type="text"
        [placeholder]="t('strategy-bulk-upload-modal.paste_csv_here')"
        (input)="textareaInputChange($event)"
        [value]="textareaValue()"
      >
      {{ textareaValue() }}
      </textarea>

      <div class="flex w-full items-center justify-end">
        <button iButton [disabled]="!canPreview()" (click)="emitPreview()">
          {{ t("common.next") }}
        </button>
      </div>

      <div class="flex w-full items-center justify-center text-sm text-gray-400 uppercase">
        <div class="h-px w-full flex-1 border-t border-dashed border-gray-200"></div>
        <div class="px-2">{{ t("common.or") }}</div>
        <div class="h-px w-full flex-1 border-t border-dashed border-gray-200"></div>
      </div>

      <div>
        <button iButton variant="secondary" size="md" class="relative text-gray-600" (click)="fileInput.click()">
          <IIcon name="fileSpreadsheet" />
          {{ t("bulk-upload.upload_file") }}
        </button>
        <input #fileInput hidden type="file" accept=".csv,.tsv" (change)="uploadFile($event)" />
      </div>
    </div>
  }
</ng-container>
